import { render, staticRenderFns } from "./ServiceProductCard.vue?vue&type=template&id=0a108735&scoped=true"
import script from "./ServiceProductCard.vue?vue&type=script&lang=js"
export * from "./ServiceProductCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceProductCard.vue?vue&type=style&index=0&id=0a108735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a108735",
  null
  
)

export default component.exports